import {getMfaRedirectUrl, MfaInfoFailCode, MfaInfoErrorCode, type MfaError} from '@financial/auth-node-package'
import {isAxiosError} from 'axios'
import queryString from 'query-string'

import {getCurrentUrl, getOrigin} from '$utils/common'

import type {MfaSessionFail, MfaPersistFail} from '@financial/auth-node-package'
import type {AxiosError} from 'axios'
import type {GetServerSidePropsContext} from 'next'

function isMfaPersistFail(response: unknown): response is MfaPersistFail | MfaError {
    const isResponseDataObject = !!response && typeof response === 'object'
    const isMfaErrorObject = isResponseDataObject && 'code' in response

    /**
     * @example
     * {
     *   data: 'MFA_99',
     *   message: '[인증키 누락 오류] nid_gskey 또는 NAPP_DI 쿠키가 누락되었습니다'
     * }
     */
    const isMfaInfoErrorCode = isMfaErrorObject && response.code === MfaInfoErrorCode

    /**
     * @example
     * {
     *   data: 'MFA_11',
     *   serviceCode: 'myasset',
     *   message: ''
     * }
     */
    const isMfaPersistErrorCode =
        isMfaErrorObject && response.code === MfaInfoFailCode.PersistFail && 'serviceCode' in response

    return isMfaInfoErrorCode || isMfaPersistErrorCode
}
export function isPayAppOneDeviceInvalidError(error: AxiosError) {
    return isMfaPersistFail(error.response?.data || {})
}

function isMfaSessionErrorResponse(response: unknown): response is MfaSessionFail {
    return response !== null && typeof response === 'object' && 'code' in response && 'sessionKey' in response
}
export function isMfaSessionError(error: AxiosError) {
    return isMfaSessionErrorResponse(error.response?.data || {})
}

export function getRedirectUrlFromMfaError(error: unknown, context?: GetServerSidePropsContext) {
    if (!isAxiosError(error) || !isMfaSessionErrorResponse(error.response?.data)) {
        return null
    }
    const rurl = getCurrentUrl(context)
    const origin = getOrigin(context?.req, {withBasePath: false})
    const surl = `${origin}/mydata/home`
    // 페이앱_안드로이드 환경에서 queryString.stringify 로 키패드 URL을 생성할 때 페이지 요청을 하지 않는 이슈가 있어서 롤백한 이력있음
    // 정확한 원인 파악을 못했지만 수동으로 rurl, surl, sessionKey 를 포함한 URL을 생성하여 해결함
    return getMfaRedirectUrl({statusCode: error.response.status, mfaInfo: error.response.data, rurl, surl})
}

export function getRedirectPayappUrlFromMfaError(error: unknown, context?: GetServerSidePropsContext) {
    if (!isAxiosError(error) || !isMfaSessionErrorResponse(error.response?.data)) {
        return null
    }

    const origin = getOrigin(context?.req, {withBasePath: false})
    const rurl = getCurrentUrl(context)
    const surl = `${origin}/mydata/home`
    const {sessionKey} = error.response.data
    const queryParams = queryString.stringify({rurl, surl, sessionKey})

    return `${origin}/authentication/pw/check-payapp-mfa?${queryParams}`
}

export function getRedirectPayAppAuthError(error: unknown, context?: GetServerSidePropsContext) {
    if (!isAxiosError(error) || !isMfaPersistFail(error.response?.data)) {
        return
    }
    const origin = getOrigin(context?.req, {withBasePath: true})
    return `${origin}/bridge/pay-app-auth-error`
}
